import { type EMRKindID, type EMRTypeID } from './_EMR.ts'

export const GAHTFHTConsent_ID = 'imago.gaht.fht-consent' as EMRTypeID & EMRKindID
export const GAHTMHTConsent_ID = 'imago.gaht.mht-consent' as EMRTypeID & EMRKindID
